import moment from "moment";

export const formatMifosDate = (mifosDate) => {
  if (mifosDate) {
    return moment(new Date(mifosDate)).format("YYYY-MM-DD");
  } else {
    return null;
  }
};
